var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 666.7",
    style: {
      enableBackground: "new 0 0 600 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:66.6667;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:133.3333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication__x2F__Share_x5F_iOS_x5F_Export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M200,133.3l100-100 M300,33.3l100,100 M300,33.3v333.3 M133.3,266.7c-31.1,0-46.6,0-58.8,5.1 c-16.3,6.8-29.3,19.8-36.1,36.1c-5.1,12.2-5.1,27.8-5.1,58.8v160c0,37.3,0,56,7.3,70.3c6.4,12.5,16.6,22.8,29.1,29.2 c14.2,7.3,32.9,7.3,70.2,7.3h320.2c37.3,0,55.9,0,70.1-7.3c12.5-6.4,22.8-16.6,29.1-29.2c7.3-14.2,7.3-32.9,7.3-70.1V366.7 c0-31.1,0-46.6-5.1-58.8c-6.8-16.3-19.7-29.3-36.1-36.1c-12.3-5.1-27.8-5.1-58.8-5.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.8711bc9fcc831e34518d584b6e444cd7.svg";
export { ForwardRef as ReactComponent };